'use client'

import { useBIPageView } from '@/context/BISdkContext'
import { PropsWithChildren } from 'react'

export default function GenrePageWrapper({ children }: PropsWithChildren) {
  useBIPageView()

  return (
    <main className="flex flex-1 flex-col justify-center gap-2 px-4 py-6 md:px-6 md:py-10">
      {children}
    </main>
  )
}
